import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-template',
  templateUrl: './forgot-password-template.component.html',
})
export class ForgotPasswordTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
